module.exports = __webpack_public_path__ + "img/beacon-base.1228db94.png";